import * as yup from 'yup';
import {i18n2} from 'features/i18n/i18n';

export const StageSchema = (onlyRead = false) => {
  const realStageSchema = () =>
    yup.object({
      iD_Instance: yup.number().label(i18n2._('#Instancia')),
      iD_Course: yup
        .string()
        .required(i18n2._('Este campo es obligatorio'))
        .label(i18n2._('#Curso')),
      course_Name: yup.string().label(i18n2._('Nombre del curso')),
      modality: yup
        .number()
        .required(i18n2._('Este campo es obligatorio'))
        .label(i18n2._('Modalidad')),
      sector: yup
        .number()
        .required(i18n2._('Este campo es obligatorio'))
        .label(i18n2._('#Sector')),
      sector_Name: yup.string().label(i18n2._('Nombre del sector')),
      instance_Date: yup
        .date()
        .typeError(i18n2._('Ingrese una fecha correcta'))
        .label(i18n2._('Fecha de instancia')),
      observations: yup
        .string()
        .nullable()
        .max(255)
        .label(i18n2._('Observacion')),
      status: yup.number().label(i18n2._('Estado')),
      capaIniLeg: yup
        .number()
        .max(8)
        .nullable(true)
        .label(i18n2._('Capa inicial')),
      duration: yup
        .number()
        .transform((value, originalValue) =>
          originalValue === '' ? undefined : value,
        )
        .typeError(i18n2._('Ingrese un número correcto'))
        .required(i18n2._('Este campo es obligatorio'))
        .moreThan(0, i18n2._('El valor debe ser mayor a 0'))
        .label(i18n2._('Duracion')),
      instructor: yup
        .string()
        .required(i18n2._('Este campo es obligatorio'))
        .max(30)
        .label(i18n2._('Instructor')),
      expiration_Date: yup
        .date()
        .required(i18n2._('Este campo es obligatorio'))
        // .typeError(i18n2._('Ingrese una fecha correcta'))
        .label(i18n2._('Vencimiento de la instancia')),
      revision: yup.number().label(i18n2._('Revision')),
      reason: yup
        .string()
        .max(255)
        .required(i18n2._('Este campo es obligatorio'))
        .label(i18n2._('Motivo')),
      updateDate: yup.date().label(i18n2._('Fecha de actualizacion')),
      updatedBy: yup.string().label(i18n2._('Actualizado por')),
      deleted: yup.boolean().label(i18n2._('Eliminado')),
    });

  const readOnlySchema = () =>
    yup.object({
      // presentRate: yup
      //     .number()
      //     .label(i18n2._('Asistencia (%)')),
      // onTimeRate: yup
      //     .number()
      //     .label(i18n2._('OnTime (%)')),
      // passRate: yup
      //     .number()
      //     .label(i18n2._('Aprobados (%)')),
    });

  return onlyRead === false
    ? realStageSchema()
    : readOnlySchema().concat(realStageSchema());
};
